import React, {Component} from 'react'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/hivec-video-1.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 0 }} 
      />
    </div>
  );
};




const KidneyHealth = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)
    switch (language) {
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
                        <h3>Здрави бъбреци!</h3>
                            <p>
Бъбречноклетъчният карцином, злокачествен тумор, произхождащ от бъбречния паренхим, е сравнително рядка форма на рак на бъбреците. Последните оценки на Института "Робърт Кох" сочат, че годишно приблизително 8 800 мъже и 5 100 жени са диагностицирани с рак на бъбрека. Ранният стадий на бъбречноклетъчния карцином обикновено протича с малко симптоми. С напредването на заболяването обаче пациентите могат да изпитат различни симптоми, включително нежелана загуба на тегло, загуба на апетит, умора, анемия, постоянна ниска температура, кървава или много тъмна урина, тъпа болка в страничната част на гърба (болка във фланга), нова поява на високо кръвно налягане и подуване на краката.</p>
                            <p>
Причините за появата на рак на бъбреците все още не са ясно установени, но са идентифицирани няколко рискови фактора. Тютюнопушенето е значителен рисков фактор, както и редовната употреба на някои болкоуспокояващи, затлъстяването, високото кръвно налягане и излагането на химикали и замърсители. Наследствени фактори, като болестта на фон Хипел-Линдау и хроничната бъбречна недостатъчност, също играят роля за развитието на рак на бъбреците.</p>
                            <p>
Туморите на бъбреците обикновено се откриват за първи път случайно по време на ултразвуково изследване. За да се разграничат злокачествените тумори от доброкачествените процеси на бъбреците, се извършва напречно изобразяване с помощта на компютърна томография или ядрено-магнитен резонанс на корема. Това изследване се използва за определяне на размера и степента на тумора в бъбрека и за диагностициране на евентуално засягане на съседни органи или лимфни възли. Трябва да се проведе и интервю с пациента, физически преглед, лабораторни изследвания и изследване на урината.</p>
                            <p>
Единствената потенциално лечебна възможност за лечение на бъбречноклетъчен карцином е хирургичното отстраняване на тумора. Други методи на лечение включват студено или радиочестотно отстраняване на тумора, които са възможности, ограничени до тумора. В някои случаи активното наблюдение може да е подходящо за малки бъбречни тумори с размер под 4 cm при пациенти в напреднала възраст или при лица с един бъбрек. В такива случаи се препоръчва редовно урологично проследяване с помощта на напречни изображения и ултразвук.
                        </p>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
 
                                <h3>Kidney health check-up</h3>
                            <p>
Renal cell carcinoma, a malignant tumor originating from the renal parenchyma, is a relatively rare form of kidney cancer. The latest estimates from the Robert Koch Institute indicate that approximately 8,800 men and 5,100 women are diagnosed with renal cancer annually. Early-stage renal cell carcinoma typically presents with few symptoms. However, as the disease progresses, patients may experience a variety of symptoms, including unwanted weight loss, loss of appetite, fatigue, anemia, persistent low-grade fever, bloody or very dark urine, dull pain in the lateral back (flank pain), new onset of high blood pressure, and swollen legs.</p>
<p>
The causes of kidney cancer have yet to be clearly established, but several risk factors have been identified. Smoking is a significant risk factor, as are regular use of certain painkillers, obesity, high blood pressure, and exposure to chemicals and pollutants. Hereditary factors, such as von Hippel-Lindau disease and chronic renal failure, also play a role in the development of kidney cancer.</p>
<p>
Renal tumors are usually first detected by chance during ultrasound examinations. To differentiate malignant tumors from benign processes of the kidney, cross-sectional imaging is performed using CT or MRI scans of the abdomen. This examination is used to determine the size and extent of the tumor in the kidney and to diagnose any possible involvement of neighboring organs or lymph nodes. A patient interview, physical examination, laboratory tests, and urinalysis should also be performed.</p>
<p>
The only potentially curative option for treating renal cell carcinoma is surgical removal of the tumor. Other treatment methods include cold or radiofrequency-assisted tumor removal, which are options limited to the tumor. In some cases, active surveillance may be appropriate for small renal tumors less than 4 cm in elderly patients or individuals with a single kidney. Regular urological follow-up using cross-sectional imaging and ultrasound is recommended in such cases.
                                <hr/>
 
                            </p>
 
                    </div>
                </section>
            )
    }


}

export default KidneyHealth



// WEBPACK FOOTER //
// ./src/Components/KidneyHealth.js